import Link from "next/link";
import Image from "next/image";
import { useState, useEffect } from "react";
import { Ads, StickyAds } from "../../../ads/Ads";
import MiniSearch from "minisearch";
import { GlobalShare } from "../../../SocialButtons";
import LocalLatestNews from "../parts/LocalLatestNews";
import SearchIcon from "../../../../../public/images/icons/search-icon.png";
import ProvincialCityContests from "../parts/ProvincialCityContests";
import styles from "../../../../styles/races/local/LocalRace.module.scss";

const LocationDesc = ({ className, title, desc }) => {
  return (
    <div className={className}>
      <h1>{title}</h1>
      <p dangerouslySetInnerHTML={{ __html: desc }} />
    </div>
  );
};

const ProvincialCityPage = ({
  path,
  url,
  info,
  taguigLoneDistrict,
  provincialCities,
  contests,
  presidential,
  vPresidential,
  senatorialList,
  partyList,
  allPartyList,
  regionList,
  view = "local-results",
}) => {
  const [query, setQuery] = useState("");
  const [isMounted, setIsMounted] = useState(true);
  const loader = ({ src, width, quality }) => {
    const imageUrl = process.env.SITE_URL;
    return `${imageUrl}${src}?w=${width}&q=${quality || 75}`;
  };
  const miniSearch = new MiniSearch({
    fields: ["name"],
    storeFields: ["name", "display_name", "slug"],
  });

  useEffect(() => {
    if (isMounted) {
      if (info) {
        setIsMounted(true);
      }
    }

    return () => {
      setIsMounted(false);
    };
  }, [info, isMounted]);

  const searchLocal = () => {
    const result = miniSearch.search(query, { prefix: true, fuzzy: 0.2 });
    if (result.length) {
      return result;
    } else {
      return [];
    }
  };

  const listLocalByPath = () => {
    miniSearch.removeAll();
    miniSearch.addAll(provincialCities);
    return searchLocal();
  };

  const onChange = (event) => {
    const query = event.target.value;
    setQuery(query);
  };

  const subParentBreadcrumb = () => {
    switch (true) {
      case info?.province?.slug === "ncr":
        return {
          path: "/elections/2022/metro-manila",
          title: "Metro Manila",
        };
      case info?.province?.slug !== "ncr" && info?.legal_class === "ICC":
        return {
          path: "/elections/2022/independent-cities",
          title: "Independent cities",
        };
      default:
        return {
          path: `/elections/2022/${info?.province?.slug}`,
          title: info?.province?.display_name,
        };
    }
  };

  return (
    <div className={styles.locRaceContainer}>
      <Ads
        deviceType="mobile"
        id="ad-local-billboard-mobile"
        adType="billboard"
        pageType="elec_local_candidates"
      />

      <h2 className={styles.removeBorder}>
        LOCAL RACES
        <ul className={styles.breadcrumbs}>
          {!info?.province &&
          info?.province?.slug !== "ncr" &&
          info?.legal_class !== "ICC" ? (
            <li>
              <Link href={`/elections/2022/provinces`} passHref>
                <a>Provinces</a>
              </Link>
            </li>
          ) : (
            ""
          )}
          {info?.province && (
            <li>
              <Link href={subParentBreadcrumb().path} passHref>
                <a>{subParentBreadcrumb().title}</a>
              </Link>
            </li>
          )}
          <li>
            <Link href={`/elections/2022/${info?.slug}`} passHref>
              <a>{info?.display_name}</a>
            </Link>
          </li>
        </ul>
      </h2>

      <div className={styles.locRaceWrapper}>
        <div className={styles.searchCity}>
          <div className={styles.search}>
            <input
              className={styles.searchBox}
              name="province/city"
              type="text"
              placeholder={`Select City or Municipality in ${
                info.province ? info.province.display_name : info.display_name
              }`}
              value={query}
              onChange={onChange}
              autoComplete="off"
            />
            <div className={styles.searchIcon}>
              <Image
                loader={loader}
                src={SearchIcon}
                alt="search"
                layout="responsive"
                width={17.49}
                height={17.49}
              />
            </div>
          </div>
        </div>
        {query.length >= 2 && (
          <div className={styles.cityListContainer}>
            {listLocalByPath()?.length
              ? listLocalByPath().map((res) => (
                  <Link
                    key={res.id}
                    href={`/elections/2022/${res.slug}`}
                    passHref
                  >
                    <a className={styles.cityName}>{res.display_name}</a>
                  </Link>
                ))
              : "No results found."}
          </div>
        )}
      </div>
      <Ads
        deviceType="desktop"
        id="ad-local-billboard-desktop"
        adType="billboard"
        pageType="elec_local_candidates"
      />
      <div className={styles.contentsContainer}>
        <div className={styles.gs_mobile}>
          <GlobalShare
            title="Share this page"
            url={url}
            fbQuote="2022 Philippine Elections - local races"
            tWQuoute="2022 Philippine Elections - local races"
            toolTipId={"toolTip_localraces_mobile"}
            isMounted={isMounted}
          />
        </div>
        <ProvincialCityContests
          type={`/elections/2022/${info.slug}`}
          isMounted={isMounted}
          info={info}
          taguigLoneDistrict={taguigLoneDistrict}
          contests={contests}
          presidential={presidential}
          vPresidential={vPresidential}
          senatorialList={senatorialList}
          partyList={partyList}
          allPartyList={allPartyList}
          view={view}
          regionList={regionList?.results}
        >
          <LocationDesc
            className={
              path === "/elections/2022/ncr"
                ? styles.description
                : `${styles.description} ${styles.hidden}`
            }
            title={info.display_name}
            desc={info?.description}
          />
        </ProvincialCityContests>

        <div className={styles.others}>
          <GlobalShare
            title="Share this page"
            url={url}
            fbQuote="2022 Philippine Elections -local races"
            tWQuoute="2022 Philippine Elections -  local races"
            toolTipId={"toolTip_localraces_desktop"}
            isMounted={isMounted}
          />
          <div className={styles.adMiddle1}>
            <Ads
              deviceType="desktop"
              id="ad-local-middle1-desktop"
              adType="middle1"
              pageType="elec_local_candidates"
            />
          </div>
          <LocationDesc
            className={
              path === "/elections/2022/ncr"
                ? `${styles.description} ${styles.hidden}`
                : styles.description
            }
            title={
              path !== `/elections/2022/${info.slug}`
                ? info?.display_name
                : info?.display_name
            }
            desc={info?.description}
          />
          <div className={styles.others_ad}></div>
          {/* <LocalLatestNews /> */}
          <div className={styles.adMiddle2}>
            <Ads
              deviceType="desktop"
              id="ad-local-middle2-desktop"
              adType="middle2"
              pageType="elec_local_candidates"
            />
          </div>
        </div>
      </div>
      <Ads
        deviceType="mobile"
        id="ad-local-leaderboard1-mobile"
        adType="leaderboard1"
        pageType="elec_local_candidates"
      />

      <StickyAds
        deviceType="desktop"
        id="ad-local-sticky-desktop"
        pageType="elec_local_candidates"
      />
      <StickyAds
        deviceType="mobile"
        id="ad-local-sticky-mobile"
        pageType="elec_local_candidates"
      />
    </div>
  );
};

export default ProvincialCityPage;
